import Immutable from 'immutable';

const Content: {
  id: string,
  type: string,
  displayType: string,
  description: string,
  progress: number | null,
  closeDelay: number | null,
  openDelay: number | null
} = {
  id: '',
  type: '',
  displayType: '',
  description: '',
  progress: null,
  closeDelay: null,
  openDelay: null
};

class Progress extends Immutable.Record(Content) {
  get name (): string {
    return this.description;
  }
}

export default Progress;
